export default __webpack_public_path__ + "static/media/Shape.38483a49.svg";